export default function facebookProduct(productArray) {
  return productArray?.length
    ? productArray.map((produto) => ({
        id: produto.id,
        item_price: produto?.variacoes[0]?.anuncios[0]?.preco?.por,
      }))
    : []
}
